// extracted by css-extract-rspack-plugin
export default {"Chip":"Chip_Chip__ScK3u"};